import { gridGutterHalf, gridGutter1q4, gridGutter, borderRadiusBase, fontSize12, fontSize32, fontSize20, fontSize16, fontSizeBase, fontSize24 } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'

export const banner = `
  margin: 0 0 ${gridGutter}px 0;
  
  @media screen and (max-width: 767px) {
    background-color: #eaf2fd;;
  }
  @media (max-width: 700px) and (orientation: landscape) {
    margin: 0 0 ${gridGutterHalf}px 0;
  }
`

export const headerTitle = `
  margin: 0;
  max-width: 60%;
  color: #2d8abd;
  font-weight: 800;
  text-transform: initial;
  font-size: ${fontSize32};
  
  @media screen and (max-width: 991px) {
    max-width: 60%;
    font-size: ${fontSize20};
  }

  @media screen and (max-width: 767px) {
    max-width: initial;
    font-size: ${fontSize16};    
  }
  
  @media (max-width: 700px) and (orientation: landscape) {
    font-size: ${fontSize20};
  }

  @media (max-width: 480px) and (orientation: landscape) {
    font-size: ${fontSizeBase};
  }
`
export const headerSubtitle = `
  display: block;
  font-weight: 800;
  color: #3f3f3f;
  margin: ${gridGutterHalf}px 0 ${gridGutter}px 0;
  
  @media screen and (max-width: 767px) {
    margin: ${gridGutter1q4}px 0 ${gridGutterHalf}px 0;
  }
`
export const headerLead = `
  margin-bottom: 0;
  color: #879395;
  font-weight: 400;
  font-size: ${fontSize20};
  max-width: 60%;
  
  @media screen and (max-width: 991px) {
    font-size: ${fontSize16};

  }

  @media screen and (max-width: 767px) {
    max-width: initial;
    font-size: ${fontSizeBase};
  }

  @media (max-width: 700px) and (orientation: landscape) {
    max-width: 70%;
  }
  
  @media (max-width: 480px) and (orientation: landscape) {
    max-width: 80%;
    font-size: ${fontSize12};
  }
`

export const flexWrapper = `
  display: flex;
  justify-content: space-between;
`

export const title = `
  font-weight: 500;
  color: #3f3f3f;
  font-size: ${fontSize20};
  margin: 0 0 ${gridGutter}px 0;

  @media screen and (max-width: 767px) {
    font-size: ${fontSize16};
  }
`

export const marginBottom = `
  @media screen and (max-width: 767px) {
    margin-bottom: ${gridGutterHalf}px;
  }
`

export const ilustration = `
  margin-top: ${gridGutter}px;
  height: 365px;
  display: flex;  
  flex-direction: column;
  justify-content: center;
  background-image: url(https://maxmilhas.s3.amazonaws.com/assets/img/ponte-aerea-max/ilustration.svg);
  background-size: contain;
  background-position: center right;
  background-repeat: no-repeat;
  
  @media screen and (max-width: 991px) {
    margin: 0;
    background-size: 40%;
    background-position: center right;
    height: 265px;
  }
  
  @media screen and (max-width: 767px) {
    margin: ${gridGutterHalf}px 0 0 0;
    height: 235px;
    background-size: contain;
    justify-content: flex-start;
    background-position: center 100px;
  }
  
  @media (max-width: 700px) and (orientation: landscape) {
    margin: 0;
    height: 165px;
    background-size: 30%;
    justify-content: center;
    background-position: center right;
  }
 
  @media (max-width: 480px) and (orientation: landscape) {
    height: 110px;
    background-size: 25%;
  }
`

export const wrapper = `
  margin: 0 0 ${gridGutter * 2}px 0;

  &:after {
      display: block;
      content: "";
      clear: both;
  }
  
  &:last-of-type {
    margin-bottom: 0;
  }
  
  @media screen and (max-width: 767px) {
    margin: 0 0 ${gridGutter}px 0;
  }
`

export const centerBlockMessage = `
  margin: ${gridGutter}px auto;
  text-align: center;

  p {
    color: #879395;
    margin-bottom: ${gridGutter}px;

    @media screen and (max-width: 767px) {
      font-size: ${fontSize12};
    }
  }
`

export const flexWrap = `
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`

export const well = `
  background: #edf3f8;
  padding: ${gridGutter * 2}px;
  margin-bottom:  ${gridGutter}px;
  border-radius: ${borderRadiusBase};

  .flex-item {    
    flex: 2;

    > div {
      margin: 0 ${gridGutter1q4}px 0 0;
    }

    + .flex-item {
      flex: 1;
      display: flex;

      > div {
        margin: 0 0 0 ${gridGutter1q4}px;    
      }
    }

    @media screen and (max-width: 767px) {    
      margin-bottom: ${gridGutterHalf}px;

      &:last-of-type {
        margin-bottom: 0;
      }

      > div {
        margin: 0;
      }
  
      + .flex-item {
        > div {
          margin: 0;    
        }
      }
    }
  }

  h3 {
    margin-bottom: 0;
    font-size: ${fontSize24};
  }
  
  @media screen and (max-width: 991px) {
    padding: ${gridGutter}px;
    margin-top: ${gridGutter}px;
    
    h3 {
      font-size: ${fontSize16};
      margin-bottom: ${gridGutterHalf}px;
    }
  }

  @media screen and (max-width: 767px) {
    padding: ${gridGutterHalf}px;
  }
`